<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  data() {
    return {
      countdown: null,
      days: 0,
      hours: 0
    };
  },
  mounted() {
    if (!!this.content.date) {
      this.setCountdown(new Date(this.content.date));
    }
  },
  methods: {
    setCountdown(date) {
      const now = new Date();
      const nowOffset = now.getTimezoneOffset();
      const dateOffset = date.getTimezoneOffset();
      now.setUTCHours(now.getUTCHours() + ((dateOffset - nowOffset)/60));

      if (now < date) {
        let breakdown = null;
        const nextTimeout = new Date(now);
        nextTimeout.setUTCMinutes(date.getUTCMinutes());
        nextTimeout.setUTCSeconds(date.getUTCSeconds());
        nextTimeout.setUTCMilliseconds(date.getUTCMilliseconds());
        if (nextTimeout <= now) {
          nextTimeout.setUTCHours(now.getUTCHours() + 1);
        }
        breakdown = nextTimeout - now;
        Vue.set(this, 'hours', Math.floor((date - now)/3600000 % 24));
        Vue.set(this, 'days', Math.floor((date - now)/86400000));

        const countdown = setTimeout(() => {
          this.setCountdown(date);
        }, breakdown);
        Vue.set(this, 'countdown', countdown);
      } else {
        Vue.set(this, 'hours', 0);
        Vue.set(this, 'days', 0);
      }
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    },
    style() {
      const style = {};
      if (this.content.height) {
        style["--stripe-height"] = this.content.height;
      }
      if (this.content.height_mobile) {
        style["--stripe-height-mobile"] = this.content.height_mobile;
      }
      return style;
    }
  }
};
</script>

<template>
  <div 
    stripe-countdown-component
    :class="contentType" 
    v-easyadmin="easyadminId" 
    class="position-relative"
    :style="style"
    v-if="isContentVisibleToUser()" 
  >
    <div class="bg-cover-center d-flex flex-column page-header position-relative">
      <div class="first-stripe bg-cover-center" :style="{'background-image': getContentResponsiveImageURL('background_image')}">
        <breadcrumb :breadcrumb="pageModel.breadcrumb"></breadcrumb>
      </div>
      <div class="second-stripe container position-relative">
        <div class="row justify-content-center position-absolute w-100">
          <div class="col-12 col-xl-10 px-md-0">
            <div class="row justify-content-center px-3">
              <div class="contact-item col-6 col-sm-5 col-md-3 pb-2 pb-md-0 px-2 px-md-3">                
                <div class="px-4 py-3 py-md-4 h-100 w-100 d-flex flex-md-column tile-shadow bg-primary align-items-center text-white">
                  <div class="d-flex flex-column py-2 py-md-3 mx-auto">
                    <h1 class="mb-0 number">{{days}}</h1>
                    <h3 class="font-weight-bold mb-0s">giorni</h3>
                  </div>
                </div>
              </div>
              <div class="contact-item col-6 col-sm-5 col-md-3 pb-2 pb-md-0 px-2 px-md-3">   
                <div class="px-4 py-3 py-md-4 h-100 w-100 d-flex flex-md-column bg-primary tile-shadow align-items-center text-white">
                  <div class="d-flex flex-column py-2 py-md-3 mx-auto">
                    <h1 class="mb-0 number">{{hours}}</h1>
                    <h3 class="font-weight-bold mb-0">ore</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-countdown-component] {

  .page-header {
    height: var(--stripe-height, 70vh);

    .first-stripe {
      flex: 2;
    }
    .second-stripe {
      flex: 1;
      & > div:first-child {
        top: -35%;
      }
    }

    @include media-breakpoint-down(sm) {
      & {
        height: var(--stripe-height-mobile, 85vh);
      }
    }
  }

  .contact-item {
    .number {
      font-family: 'VodafoneRg';
      font-weight: bold;
    }
    & > div {
      border-radius: 6px;
      transition: all .25s;
      text-align: center;

      @include hover {
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.32);
      }
    }
  }
}
</style>